import { rejectionReasonsSlice } from "./rejectionReasonsSlice";
import * as actions from "./rejectionReasonsActions";
import * as selectors from "./rejectionReasonsSelectors";

export { actions };
export { selectors };
export default rejectionReasonsSlice.reducer;
